import React, { useEffect, useReducer } from "react";
import { View, Text, TextInput } from "react-native";
import Colors from "../constants/Colors";
const INPUT_CHANGE = "INPUT_CHANGE";
const INPUT_BLUR = "INPUT_BLUR ";
const INPUT_FOCUS = "INPUT_FOCUS";

const inputReducer = (state, action) => {
  switch (action.type) {
    case INPUT_CHANGE:
      return {
        ...state,
        value: action.value,
        validity: action.validity,
      };
    case INPUT_BLUR:
      return {
        ...state,
        focused: false,
        touched: true,
      };
    case INPUT_FOCUS:
      return {
        ...state,
        value: "",
        focused: true,
      };
    default:
      return state;
  }
};

const Inputak = (props) => {
  const { onInputChange, id } = props;
  const [inputState, dispatchInputState] = useReducer(inputReducer, {
    value: props.initialValue ? props.initialValue : "",
    validity: props.initialValidity,
    touched: false,
    focused: false,
  });

  useEffect(() => {
    onInputChange(id, inputState.value, inputState.validity);
  }, [id, inputState, onInputChange]);

  const textChangeHandler = (value) => {
    const emailRegex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let validity = true;
    if (props.required && value.trim().length === 0) {
      validity = false;
    }
    if (props.email && !emailRegex.test(value.toLowerCase())) {
      validity = false;
    }
    if (props.min != null && +value < props.min) {
      validity = false;
    }
    if (props.max != null && +value > props.max) {
      validity = false;
    }
    if (props.minLength != null && value.length < props.minLength) {
      validity = false;
    }
    dispatchInputState({
      type: INPUT_CHANGE,
      value,
      validity,
    });
    if (validity) {
    }
  };

  const onBlurHandler = () => {
    dispatchInputState({ type: INPUT_BLUR });
  };
  return (
    <View
      style={{
        width: 50,
        alignItems: "center",
        paddingHorizontal: 2,
        marginBottom: 20,
        ...props.style,
      }}
    >
      <Text
        style={{
          fontFamily:"Montserrat",
          fontSize: 16,
          marginBottom: 15,
          marginRight: 3,
          color: inputState.focused ? Colors.primary : Colors.secondText2,
        }}
      >
        {props.label}
      </Text>
      <TextInput
        style={{
          backgroundColor:Colors.background,
          fontFamily:"Montserrat",
          fontSize: 16,
          color: Colors.black,
          width: "100%",
          borderRadius: 7,
          textAlign: "center",
          paddingHorizontal: 15,
          shadowOpacity: 0.3,
          shadowOffset: { width: 0, height: 0 },
          height: props.multiline ? 150 : 50,
          borderWidth: inputState.focused ? 1.5 : 1.5,
          borderColor: inputState.focused ? Colors.primary : Colors.secondText,
          shadowColor: inputState.focused ? Colors.primary : Colors.secondText,
          ...props.styleinput
        }}
        multiline={props.multiline ? true : false}
        numberOfLines={props.numberOfLines}
        value={inputState.value}
        onBlur={onBlurHandler}
        onFocus={() => {
          dispatchInputState({ type: INPUT_FOCUS });
        }}
        onChangeText={textChangeHandler}
        maxLength={1}
        ref={props.inputref}
        keyboardType="numeric"
        autoComplete="sms-otp"
      />
    </View>
  );
};

export default Inputak;
